import { render } from "./Sidebar.vue?vue&type=template&id=e80d943a&scoped=true&ts=true"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"

import "./Sidebar.vue?vue&type=style&index=0&id=e80d943a&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e80d943a"]])

export default __exports__